<template>
    <a href="javascript:void(0)" @click="onButtonClick"  class="no-underline">
        <i class="fas fa-angle-left"></i> Back
    </a>
</template>

<script>
    export default {
        name: 'BackLink',
        props: ['component'],
        data () {
            return {
                model: webase.model
            }
        },
        mounted () {
        },
        methods: {
            onButtonClick () {
                this.$router.go(-1)
            }
        }
    }
</script>

<style>

</style>
